// src/firebase-sw-register.js
export const registerServiceWorker = async () => {
  if ("serviceWorker" in navigator) {
    try {
      // const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
      const registration = await navigator.serviceWorker.register("/app/firebase-messaging-sw.js");

      // console.log("✅ Service Worker registered", registration);
      return registration;
    } catch (e) {
      console.error("❌ Service Worker registration failed:", e);
    }
  } else {
    console.warn("❌ Service Workers are not supported in this browser.");
  }
};
